import { Language } from '../const';

export const getLanguageResources = async (language: string) => {
	switch (language as Language) {
		case Language.SIMPLIFIED_CHINESE:
			return {
				translation: (await import('../../locales/zh-CN/all.json')).default,
				zod: (await import('zod-i18n-map/locales/zh-CN/zod.json')).default,
			};
		case Language.TRADITIONAL_CHINESE:
			return {
				translation: (await import('../../locales/zh-HK/all.json')).default,
				zod: (await import('zod-i18n-map/locales/zh-TW/zod.json')).default,
			};
		case Language.ENGLISH:
		default:
			return {
				translation: (await import('../../locales/en-US/all.json')).default,
				zod: (await import('zod-i18n-map/locales/en/zod.json')).default,
			};
	}
};
export const ns = ['translation'];
